/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var classnames = require("classnames");
var propertyToMCSSstate_1 = require("./util/propertyToMCSSstate");
var metroUnitedSvg = require("../img/metro/global/metro-united.svg");
var metroUnitedInvertedSvg = require("../img/metro/global/metro-united-inverted.svg");
var metroSvg = require("../img/metro/global/metro-logo.svg");
var makroSvg = require("../img/metro/global/makro-logo.svg");
var metroTrSvg = require("../img/metro/global/metro-tr-logo.svg");
var makroNlSvg = require("../img/metro/global/makro-nl-logo.svg");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Logo.css'); }
exports.logoVariantMap = {
    "metro-united": metroUnitedSvg,
    "metro-united-inverted": metroUnitedInvertedSvg,
    metro: metroSvg,
    makro: makroSvg,
    "metro-tr": metroTrSvg,
    "makro-nl": makroNlSvg
};
exports.logoSizes = ["small", "medium", "large"];
var propTypes = {
    className: PropTypes.string,
    variant: PropTypes.oneOf(Object.keys(exports.logoVariantMap))
        .isRequired,
    size: PropTypes.oneOf(exports.logoSizes).isRequired
};
var defaultProps = {
    variant: "makro",
    size: "medium"
};
exports.Logo = function Logo(_a) {
    var variant = _a.variant, size = _a.size, className = _a.className;
    return (React.createElement("img", { src: exports.logoVariantMap[variant], alt: "Logo", className: classnames("m-logo", propertyToMCSSstate_1.propertyToMCSSstate("m-logo", variant), propertyToMCSSstate_1.propertyToMCSSstate("m-logo", size), className) }));
};
exports.Logo.propTypes = propTypes;
exports.Logo.defaultProps = defaultProps;